import { useEffect, useState } from "react";
import { UserPlus, Phone, Download } from "lucide-react";
import api from "@/lib/api";
import { Loader } from "@/components/common/Loader";
import { PageHeader, EmptyState, StatCard } from "@/components/dashboard/ui";

export default function AdminLeads() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/leads").then((r) => setData(r.data)).catch(() => setData({ leads: [], total: 0 })); }, []);
  if (!data) return <Loader />;

  const exportCsv = () => {
    const rows = [["Name", "Phone", "Event", "Date"], ...data.leads.map((l) => [l.name, l.phone, l.event_name, l.created_at])];
    const csv = rows.map((r) => r.map((c) => `"${(c || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = "pmr-leads.csv"; a.click();
  };

  return (
    <div>
      <PageHeader title="Marketing Leads" subtitle="Captured when clients download photos across all galleries."
        action={data.leads.length > 0 && <button data-testid="export-leads" onClick={exportCsv} className="inline-flex items-center gap-2 bg-gold text-black text-sm font-medium rounded-full px-5 py-2.5 hover:bg-gold-light"><Download className="w-4 h-4" /> Export CSV</button>} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard icon={UserPlus} label="Total Leads" value={data.total} accent />
        <StatCard icon={Phone} label="Unique Phones" value={new Set(data.leads.map((l) => l.phone)).size} />
      </div>
      {data.leads.length === 0 ? <EmptyState icon={UserPlus} title="No leads yet" desc="Leads appear here when clients enter their name & phone to download photos." /> : (
        <div className="rounded-2xl border border-border overflow-hidden">
          <div className="grid grid-cols-12 gap-4 px-5 py-3 bg-black/40 text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
            <div className="col-span-3">Name</div><div className="col-span-3">Phone</div><div className="col-span-4">Event</div><div className="col-span-2">Date</div>
          </div>
          {data.leads.map((l) => (
            <div key={l.id} data-testid={`lead-${l.id}`} className="grid grid-cols-12 gap-4 px-5 py-4 items-center border-b border-border last:border-0 hover:bg-white/[0.02] text-sm">
              <div className="col-span-3 text-white font-medium">{l.name}</div>
              <div className="col-span-3 text-gold">{l.phone}</div>
              <div className="col-span-4 text-secondary-foreground">{l.event_name}</div>
              <div className="col-span-2 text-muted-foreground text-xs">{(l.created_at || "").slice(0, 10)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
